import mixins from 'vue-typed-mixins';

import StudyMixin, { STUDY_RESULT } from '@/user/mixins/StudyMixin';
import CourseProgressMixin from '@/user/mixins/CourseProgressMixin';

import { CourseProgress } from '@/openapi/user';

import _ from 'lodash';


/** 画像ファイル拡張子 */
const IMAGE_FILE_EXT = 'svg';

export default mixins(CourseProgressMixin, StudyMixin).extend({

  name: 'StudyCalcMixin',

  data(): {
    tutorialSectionNo: number;
  } {
    return {
      tutorialSectionNo: 1
    };
  },

  computed: {
    restQuestionCount(): number {
      if (this.studyResult !== null && this.studyResult >= STUDY_RESULT.UNIT_SUCCESS)
        return this.questionCount - this.questionIndex - 1;
      else
        return this.questionCount - this.questionIndex;
    },
  },

  methods: {
    isJudgeUnit(): boolean {
      const unitCount = this.getSection(this.studySectionNo).unitCount;
      return this.studySectionNo > 0 && (this.studyUnitNo === 0 || this.studyUnitNo == unitCount + 1);
    },
    createStageName(): string {
      const name = this.getSection(this.studySectionNo).sectionName.replace(/\\n/g, '');
      return this.isTutorial ? name : `${name} (${this.studyUnitNo})`;
    },
    addQuestionImages(): void {
      const sectionNoStr = String(this.studySectionNo).padStart(2, '0');
      this.questions.forEach(q => {
        if (q.question.length > 0) return; // 問題がある場合は次へ
        const questionNoStr = String(q.questionNo).padStart(3, '0');
        q.q = this.$_getQuestionImageUrl(`section${sectionNoStr}`, `${sectionNoStr}-${questionNoStr}q.${IMAGE_FILE_EXT}`);
        q.a = this.$_getQuestionImageUrl(`section${sectionNoStr}`, `${sectionNoStr}-${questionNoStr}a.${IMAGE_FILE_EXT}`);
      });
    },

    // StudyMixin上書き
    timeupMemo(): string {
      return `TIMEUP${this.question?.questionNo}`;
    },

    // StudyMixinを上書き、学習結果保存処理用
    isCourseComplete(isCorrect: boolean): boolean {
      // 不正解の場合はfalse
      if (!isCorrect) return false;

      // 回答中のユニット以外の全単元、ユニットが終了しているか
      for (const section of this.sections) {
        const progress  = this.progresses.find(s => s.sectionNo === section.sectionNo);
        // 単元内のユニット数
        let unitCount = section.unitCount;
        if (section.sectionNo > 0)                     unitCount++; // チュートリアル以外は診断ユニット分を足す
        if (section.sectionNo === this.studySectionNo) unitCount--; // 学習中の単元は学習中ユニット分を引く
        // 単元の進捗が存在しない、もしくは単元内のユニット数より少ない場合はfalse
        if (progress === undefined || progress.unitNos.length < unitCount) return false;
      }

      return true;
    },

    // StudyMixinを上書き、学習結果保存処理用
    updateProgress(isCorrect: boolean): void {
      // 不正解の場合はreturn
      if (!isCorrect) return;

      // 進捗に学習中のユニットがない場合は追加
      const progress = this.getProgress();
      let   unitNos  = progress.unitNos;
      if (!unitNos.includes(this.studyUnitNo)) {
        unitNos.push(this.studyUnitNo);
        unitNos = _.sortBy(progress.unitNos);
      }

      // 進捗に学習中の単元がない場合は追加
      let progresses = this.progresses;
      if (!progresses.some(p => p.sectionNo === this.studySectionNo)) {
        progresses.push(progress);
        progresses = _.sortBy(progresses, p => p.sectionNo);
        this.setProgresses(progresses);
      }
    },

    // StudyMixinを上書き、学習結果保存処理用
    getProgress(): CourseProgress {
      const progress = this.progresses.find(p => p.sectionNo === this.studySectionNo);
      return progress ?? { sectionNo: this.studySectionNo, unitNos: [] };
    },
  }

});
